import React, { useState } from "react";
import styles from "./WireTransferAccountNo.module.scss";
import Modal from "../Modal/Modal";
import { useFormik } from "formik";
import InputFormik from "../../Formik/Input/InputFormik";
import { Link } from "react-router-dom";
import Button from "../../Button/Button";
import SummaryModal from "../SummaryModal/SummaryModal";

const WireTransferAccountNo = ({ show, handleClose }) => {
  const [showSummary, setShowSummary] = useState(false);
  const formik = useFormik({
    initialValues: {
      account_number: "",
    },
    onSubmit: (values) => { },
  });
  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        className={styles.account_number}
        title="Wire Transfer"
      >
        <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <InputFormik
            name="account_number"
            label="Enter your account number"
            placeholder="1234567890"
            {...formik.getFieldProps("account_number")}
            max={9}
          />
          <p>
            Not sure where to find this? <Link to="">See an example</Link>
          </p>
          <Button
            fluid
            disabled={!formik.values.account_number}
            type="button"
            onClick={() => {
              setShowSummary(true);
              handleClose();
            }}
          >
            Continue
          </Button>
        </form>
      </Modal>
      <SummaryModal
        show={showSummary}
        handleClose={() => setShowSummary(false)}
      />
    </>
  );
};

export default WireTransferAccountNo;
